import { BadRequestError } from "@excent-one/core";

export const getServerErrorMessage = (e: unknown, fallback: string): string => {
  if (e instanceof BadRequestError) {
    const errors = e.data?.errors as Record<string, string[]> | undefined;
    const messages = errors ? Object.values(errors).flat() : [];
    if (messages.length > 0) return messages.join(" ");
    if (e.data?.title) return e.data.title;
  }
  return fallback;
};
